import { SbbDateFormats } from './date-formats';

export const SBB_DATE_PIPE_DATE_FORMATS: SbbDateFormats = {
  dateInput: 'EEEEEE, dd.MM.yyyy',
  dateA11yLabel: 'dd MM yyyy',
};
